export default function reducer(
  state = {
    activeKey: '0',
    favorites: [],
    app: '',
    tools: {},
    surveyError: false,
    surveyInput: { survey: {}, name: '' },
    surveySubmitted: false,
    search: {
      search: '',
      result: []
    },
    recommendations: [],
    discover: [],
    path: ''
  },
  action
) {
  const newState = {
    ...state,
    search: {
      search: '',
      result: []
    }
  };
  switch (action.type) {
    case 'UPDATE_MYAPPS_PATH':
      return {
        ...newState,
        path: action.path
      };
    case 'UPDATE_MYAPPS_TAB':
      return {
        ...newState,
        activeKey: action.key,
        app: ''
      };
    case 'UPDATE_MYAPPS_APP':
      return {
        ...newState,
        activeKey: action.key,
        app: action.app
      };
    case 'UPDATE_MYAPPS_TOOLS':
      if (typeof action.search === 'object') {
        return {
          ...newState,
          tools: action.tools,
          favorites: action.favorites,
          activeKey: action.activeKey,
          search: action.search
        };
      }
      return {
        ...newState,
        tools: action.tools,
        favorites: action.favorites,
        activeKey: action.activeKey
      };
    case 'UPDATE_RECOMMENDED_TOOLS':
      return {
        ...newState,
        recommendations: action.recommendations
      };
    case 'CHANGE_SURVEY_COMPLETE':
      return {
        ...newState,
        surveyInput: action.data,
        surveyError: false,
        surveySubmitted: false
      };
    case 'POST_SURVEY_COMPLETE':
      return {
        ...newState,
        surveyInput: { survey: {}, name: '' },
        surveySubmitted: true
      };
    case 'ERROR_SURVEY_INPUT':
      return {
        ...newState,
        surveyError: true,
        surveySubmitted: false
      };
    default:
      return newState;
  }
}
